import { Hourglass } from 'lucide-react';
import type { ComponentType } from 'react';
import { t } from '@/lib/i18n';
import { EmptyState } from '@/ui';
import type { EntityTabProps } from '../../entityTabs';

/** A tab another module will fill; registered now so the page shape is final. */
export function placeholderTab(title: string, description: string): ComponentType<EntityTabProps> {
  function PlaceholderTab() {
    return <EmptyState icon={Hourglass} title={t('{section} is coming next', { section: t(title) })} description={t(description)} />;
  }
  return PlaceholderTab;
}
